module.exports = __webpack_public_path__ + "img/twitter.432b7cb8.svg";